import React from 'react';
import { useBooking, Stylist } from '../context/BookingContext';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
export const StylistSelection = () => {
  const {
    booking,
    setBooking,
    nextStep,
    prevStep
  } = useBooking();
  const stylists: Stylist[] = [{
    id: '1',
    name: 'Sophia Martinez',
    specialization: 'Color Specialist',
    experience: '8 years',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
  }, {
    id: '2',
    name: 'James Wilson',
    specialization: 'Cutting Expert',
    experience: '10 years',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
  }, {
    id: '3',
    name: 'Emma Thompson',
    specialization: 'Balayage & Styling',
    experience: '6 years',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
  }, {
    id: '4',
    name: 'Michael Chen',
    specialization: 'Texture & Curls',
    experience: '7 years',
    image: 'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
  }];
  const handleSelectStylist = (stylist: Stylist) => {
    setBooking(prev => ({
      ...prev,
      stylist
    }));
    nextStep();
  };
  return <div data-id="element-170">
      <h3 className="text-xl font-medium text-amber-400 mb-2" data-id="element-171">
        Choose Your Stylist
      </h3>
      <p className="text-blue-100 mb-6" data-id="element-172">
        Selected service:{' '}
        <span className="font-medium text-amber-300" data-id="element-173">
          {booking.service?.name}
        </span>
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-174">
        {stylists.map(stylist => <div key={stylist.id} className={`border rounded-lg overflow-hidden cursor-pointer transition-all hover:shadow-md ${booking.stylist?.id === stylist.id ? 'border-amber-500 ring-2 ring-amber-500/30' : 'border-blue-800'}`} onClick={() => handleSelectStylist(stylist)} data-id="element-175">
            <div className="h-48 overflow-hidden" data-id="element-176">
              <img src={stylist.image} alt={stylist.name} className="w-full h-full object-cover" data-id="element-177" />
            </div>
            <div className="p-4 bg-blue-900" data-id="element-178">
              <h4 className="text-lg font-medium text-amber-300 mb-1" data-id="element-179">
                {stylist.name}
              </h4>
              <p className="text-amber-400 text-sm font-medium mb-1" data-id="element-180">
                {stylist.specialization}
              </p>
              <p className="text-blue-200 text-sm" data-id="element-181">
                {stylist.experience} experience
              </p>
            </div>
          </div>)}
      </div>
      <div className="flex justify-between" data-id="element-182">
        <button onClick={prevStep} className="flex items-center gap-1 px-4 py-2 border border-blue-700 rounded-md text-blue-100 hover:bg-blue-800 transition-colors" data-id="element-183">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-184" /> Back
        </button>
        <button onClick={nextStep} className="flex items-center gap-1 px-4 py-2 bg-amber-500 text-blue-950 rounded-md hover:bg-amber-400 transition-colors" disabled={!booking.stylist} data-id="element-185">
          Continue <ArrowRightIcon className="w-4 h-4" data-id="element-186" />
        </button>
      </div>
    </div>;
};